import { render, staticRenderFns } from "./pay_result.vue?vue&type=template&id=c18ae87c&scoped=true&"
import script from "./pay_result.vue?vue&type=script&lang=js&"
export * from "./pay_result.vue?vue&type=script&lang=js&"
import style0 from "./pay_result.vue?vue&type=style&index=0&id=c18ae87c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18ae87c",
  null
  
)

export default component.exports